import React from 'react';
import Icon from '../Icon';
import '../../styles/components/IconButton.css';

interface IconButtonProps {
  /** Name in the shared Icon set. */
  icon: string;
  /** Accessible name. Also shown as text where the bar collapses into the mobile overflow menu. */
  label: string;
  onClick?: () => void;
  /** Tooltip. Defaults to the label. */
  title?: string;
  /** For toggles: reports aria-pressed. Leave undefined for plain actions. */
  pressed?: boolean;
}

/**
 * A bar action shown as an icon only (same box, border and hover as the other
 * .header-action-btn controls, like Kalligo's icon buttons). The label stays in
 * the DOM, visually hidden on the bar and shown as a normal labelled row inside
 * the mobile "more actions" menu, so nothing is icon-only there.
 */
export const IconButton: React.FC<IconButtonProps> = ({
  icon, label, onClick, title, pressed,
}) => (
  <button
    type="button"
    className="header-action-btn icon-btn"
    onClick={onClick}
    title={title ?? label}
    aria-label={label}
    aria-pressed={pressed}
  >
    <Icon name={icon} size={16} />
    <span className="icon-btn__label">{label}</span>
  </button>
);

export default IconButton;
